import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { SaveAdminProspectAPI } from '../../../../api/AdminAPI';
import { CATEGORY_OPTIONS, STATUS_OPTIONS, NOTE_MAX_LENGTH, SELECT_ABOVE_DIALOG } from '../prospectOptions';

const EMPTY = {
  name: '', category: 'physio', instagram: '', whatsapp: '', email: '',
  website: '', city: '', state: '', status: 'new', note: '',
};

/**
 * ProspectFormDialog - Cria ou altera um contato da Prospecção.
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {Object|null} props.prospect null = novo contato
 * @param {Function} props.onSaved recebe o contato salvo
 * @param {Function} props.onCancel
 */
function ProspectFormDialog({ isOpen, prospect, onSaved, onCancel }) {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    const base = { ...EMPTY };
    Object.keys(base).forEach((key) => {
      if (prospect && prospect[key] !== null && prospect[key] !== undefined) base[key] = prospect[key];
    });
    setForm(base);
    setError('');
  }, [isOpen, prospect]);

  const set = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleConfirm = () => {
    setSaving(true);
    setError('');
    SaveAdminProspectAPI({ ...form, id: prospect?.id ?? null }, (response) => {
      setSaving(false);
      if (!response?.success) {
        setError(response?.error || 'Não foi possível salvar.');
        return;
      }
      onSaved(response.item);
    });
  };

  const fieldProps = { size: 'small', fullWidth: true, disabled: saving };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={prospect ? 'Editar contato' : 'Novo contato'}
      variant="info"
      confirmLabel="Salvar"
      cancelLabel="Cancelar"
      onConfirm={handleConfirm}
      onCancel={onCancel}
      confirmDisabled={saving || form.name.trim() === ''}
      loading={saving}
      maxWidth={560}
    >
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1.5 }}>
        <TextField {...fieldProps} label="Nome" value={form.name} onChange={set('name')} autoFocus sx={{ gridColumn: '1 / -1' }} />
        <TextField {...fieldProps} select label="Categoria" value={form.category} onChange={set('category')} SelectProps={SELECT_ABOVE_DIALOG}>
          {CATEGORY_OPTIONS.map((item) => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
        </TextField>
        <TextField {...fieldProps} select label="Situação" value={form.status} onChange={set('status')} SelectProps={SELECT_ABOVE_DIALOG}>
          {STATUS_OPTIONS.map((item) => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
        </TextField>
        <TextField {...fieldProps} label="WhatsApp" placeholder="(11) 99999-9999" value={form.whatsapp} onChange={set('whatsapp')} />
        <TextField {...fieldProps} label="Instagram" placeholder="@perfil" value={form.instagram} onChange={set('instagram')} />
        <TextField {...fieldProps} label="E-mail" value={form.email} onChange={set('email')} />
        <TextField {...fieldProps} label="Site" value={form.website} onChange={set('website')} />
        <TextField {...fieldProps} label="Cidade" value={form.city} onChange={set('city')} />
        <TextField {...fieldProps} label="UF" value={form.state} onChange={set('state')} inputProps={{ maxLength: 2 }} />
        <TextField
          {...fieldProps}
          label="Observação"
          value={form.note}
          onChange={set('note')}
          multiline
          minRows={2}
          maxRows={6}
          inputProps={{ maxLength: NOTE_MAX_LENGTH }}
          sx={{ gridColumn: '1 / -1' }}
        />
        {error && <Alert severity="error" sx={{ gridColumn: '1 / -1' }}>{error}</Alert>}
      </Box>
    </ConfirmDialog>
  );
}

export default ProspectFormDialog;
